module.exports = __webpack_public_path__ + "img/img_logo_bi_em_03.70f0822d.png";